import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';
import { FeedbackMessage } from './types';
import moment from 'moment';
import { SharedService } from 'src/app/shareModule/services/shared.service';


@Component({
  selector: 'app-review-pending-complete',
  templateUrl: './review-pending-complete.component.html',
  styleUrls: ['./review-pending-complete.component.scss'],
})
export class ReviewPendingCompleteComponent implements OnInit {
  send_Message: FormGroup;
  google_feedbacks: any;
  edit_google_review: any;
  edit_google_feedbacks: any;
  editFG: FormGroup;
  imageUploadForm: FormGroup;
  url_names: any;
  subAdmainName: any;
  saveSubadnminid: any;
  reviewData: string;
  submitted = false;
  imgUrl = environment.ImageUrl;
  img: File;
  get_all_feedback_URL: any;
  chaeckAdminStatus: any;
  sendsmsid: any;
  inboxID: number;
  review_link: any;
  feedbackDescription: any;
  imagepreview: any;
  subAdminData: any;
  flag: any;
  hideAdminData: any;
  admindatawithid: any = 0;
  googlecoundata: any;
  getallname: any;
  selectedName: any = '';
  feedbackMessages: Array<FeedbackMessage>;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.checkUserType();
      // this.getadminlistdata();
      this.get_all_url_names();
      // this.getAllname();
      this.get_admin_All_Req();


      if (this.admindatawithid != 0) {
        this.get_feedback_subadmin_google(this.admindatawithid);
      } else {
        this.get_feedback_subadmin_google(0);
      }


      this.send_Message = this.fb.group({
        phone: ["", [Validators.required]],
      })

      this.imageUploadForm = this.fb.group({
        remark: ["", [Validators.required]],
        // subadminid: ["", [Validators.required]],
      })

      this.editFG = new FormGroup({
        feedbackNameurl: new FormControl(''),
        feedbackName: new FormControl(''),
        description: new FormControl(''),
        star: new FormControl(''),
      });
    }
  }

  onSelectName(value: string): void {
    // this.selectedName = value;
    this.send_Message.patchValue({
      phone: value
    });
  }

  checkUserType() {
    let x = localStorage.getItem("user");
    let admintype = JSON.parse(x)
    this.chaeckAdminStatus = admintype.userType
  }


  get send_Message_v() { return this.send_Message.controls }
  get imageUploadForm_v() { return this.imageUploadForm.controls }


  sendMessage() {
    this.submitted = true;
    if (this.send_Message.invalid) {
      return false;
    }
    let sendata = {
      ...this.send_Message.value,
      gfbid: this.sendsmsid,
    };
    if (this.feedbackDescription.trim() == '') {
      return this.toastr.error('Please add review.');
    }
    if (this.review_link.trim() == '') {
      return this.toastr.error('Please add review link.');
    }
    this.auth.sendSmsFeedback(sendata, this.feedbackDescription, this.review_link).subscribe(
      (response: any) => {
        this.get_feedback_subadmin_google(this.admindatawithid);
        this.toastr.success('Message sent successfully');
        this.modalService.dismissAll();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else if (error.status == 400) {
          this.toastr.error(error.error.message)
        }
      }
    );
  }

  get_feedback_subadmin_google(data) {

    this.auth.get_feedback_subadmin_google(data).subscribe(
      (response: any) => {
        this.google_feedbacks = response.body;
        console.log(this.google_feedbacks, '----this.google_feedbacks---');


        this.googlecoundata = this.google_feedbacks.length
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  get_admin_All_Req() {
    this.auth.get_admin_All_Req().subscribe(
      (response: any) => {
        // this.google_feedbacks = response.body;
        this.subAdminData = []
        this.hideAdminData = []
        this.url_names = response.body.c;
        this.getallname = response.body.b.getnameByAdmin;

        response.body.a.map((e) => {
          if (e.hideUser == 0) {
            this.subAdminData.push(e)
          } else {
            this.hideAdminData.push(e)
          }
        })

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getadminlistdata() {
    this.auth.get_admin_All_Data().subscribe(
      (response: any) => {
        // this.google_feedbacks = response.body;
        this.subAdminData = []
        this.hideAdminData = []
        response.body.map((e) => {
          if (e.hideUser == 0) {
            this.subAdminData.push(e)
          } else {
            this.hideAdminData.push(e)
          }

        })

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getDataByUser(id) {
    this.flag = id
    this.admindatawithid = id
    this.get_feedback_subadmin_google(this.admindatawithid)
    this.get_specific_feedback_manager_url(this.admindatawithid);
  }
  editReview(content: string, id: number, feedback) {

    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body.edit_feedback_subadmin_google;
        this.reviewData = response.body.data
        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'sm',
          // backdrop: 'static',
        });

        let data = this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names.findFeedbackNames[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl

        this.onChange(data)


        this.editFG.patchValue({
          feedbackNameurl: this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names.findFeedbackNames[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl,
          feedbackName: this.edit_google_feedbacks.feedbackName,
          description: this.edit_google_feedbacks.description != null ? this.edit_google_feedbacks.description : "",
          star: this.edit_google_feedbacks.star == 0 ? 5 : this.edit_google_feedbacks.star,
        });
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  get_all_url_names() {
    this.auth.get_feedback_manager_url().subscribe(
      (response: any) => {
        this.url_names = response.body;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  get_specific_feedback_manager_url(id) {
    this.auth.get_specific_feedback_manager_url(id).subscribe(
      (response: any) => {
        this.url_names = response.body.c;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onChange(event) {
    let formData = new FormData();
    formData.append('current_module', event);
    this.auth.get_all_feedback_module(formData).subscribe((response: any) => {
      (response)
      this.get_all_feedback_URL = response.body.filter(x => x.description.trim().length != 0)

    });
  }

  subonChange(data) {
    this.editFG.patchValue({
      description: data
    })
  }

  update_edit_google_feedbacks() {
    this.auth
      .update_edit_google_feedbacks(this.editFG.value, this.edit_google_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }
  verify_review(id: number) {
    this.auth.verify_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.ngOnInit();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  formateDate(date: number) {
    return moment(date * 1000).format("DD/MM/YYYY hh:mm a");
  }

  sendsms(phone: number, id, description, review_link) {
    this.sendsmsid = id;
    this.review_link = review_link;
    this.feedbackDescription = description;

    this.auth.getSmsFeedback(id).subscribe(messages => {
      this.feedbackMessages = messages.body;
      debugger;
      this.modalService.open(phone, {
        backdropClass: 'light-blue-backdrop',
        size: 'sm',
        // backdrop: 'static',
      });
      this.inboxID = id;
    })


  }

  imageUpload(content: string, id: number) {
    this.getimagdata(id)
    this.SubAdminNameSelect();
    this.getAllname();
    this.saveSubadnminid = id
    this.modalService.open(content, { size: 'sm' });
    // this.verify_review(id)
  }


  viewlimage(content: string, id) {
    this.getimagdata(id)
    this.modalService.open(content, { size: 'sm' });
    // this.verify_review(id)


  }

  getimagdata(id) {
    this.auth.get_feedbackimagedata(id).subscribe(
      (response: any) => {
        this.imagepreview = response.body.image
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }


  SubAdminNameSelect() {
    let formData = new FormData();
    formData.append('subAdminName', 'subAdmin');
    this.auth.get_subAdminName(formData).subscribe(
      (response: any) => {
        this.subAdmainName = response.body;

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onFileChanged(event) {
    this.img = event.target.files[0];
  }

  verify_review_token() {


    this.submitted = true;
    if (this.imageUploadForm.invalid) {
      return false;
    }
    const { subadminid, remark } = this.imageUploadForm.value

    const formData = new FormData()
    formData.append("image", this.img)
    // formData.append("subadminid", subadminid)
    formData.append("remark", remark)
    formData.append("saveSubadnminid", this.saveSubadnminid)
    this.auth.reviewImageUploadForm(formData).subscribe(
      (response: any) => {
        // this.subAdmainName = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.verify_review(this.saveSubadnminid)
    this.modalService.dismissAll();
  }

  unhide(even, status) {
    this.hideuserfunction(parseInt(even), status)
  }
  hideURL(id, status) {
    this.hideuserfunction(id, status)
  }

  hideuserfunction(id, status) {
    // hideUser
    this.auth.hideGoogelreview(id, status).subscribe(
      (response: any) => {
        this.getadminlistdata()
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getAllname() {
    this.auth.getnameByAdmin().subscribe(
      (response: any) => {
        this.getallname = response.body.getnameByAdmin
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }


}
